import { PageWithTitle } from './PageWithTitle';
import { ShowLoading } from 'src/shared/components/ShowLoading';

type PageWithTitleErrorProps = {
  title: string;
};

export const PageWithTitleLoading = ({ title }: PageWithTitleErrorProps) => {
  return (
    <PageWithTitle title={title}>
      <ShowLoading />
    </PageWithTitle>
  );
};
